<template>
  <MapPin
    :google="google"
    :map="map"
    :mapState="mapState"
    :hasLabel="true"
    :hasIcon="true"
    :position="position"
    @click="$emit('click', $event)">
    <template v-slot:icon>
      <div :class="`marker-endpoint-icon`">
        <i class="fas fa-home-lg" />
      </div>
    </template>
    <template v-slot:label>
      {{labelTitle}}
    </template>
  </MapPin>
</template>

<style scoped lang="scss">
.marker-endpoint-icon {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  line-height: 21px;
  vertical-align: middle;
  background-color: $label-status-despatch;
  text-align: center;
  font-size: 11px;
  color: #ffffff;
}
</style>

<script>
import MapPin from '@/components/maps/mapPin'

export default {
  name: 'MapTaskEndpointMarker',
  components: {
    MapPin
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    isStartPoint: Boolean,
    isEndPoint: Boolean,
    mapState: Object,
    task: Object
  },
  data() {
    return {
    }
  },
  computed: {
    labelTitle() {
      if(this.isStartPoint && !this.isEndPoint)
        return 'Start'
      if(!this.isStartPoint && this.isEndPoint)
        return 'End'

      return 'Start / End'
    }
  },
  watch: {
  },
  mounted() {

  },
}
</script>